import { useContext } from 'react';
import * as router from 'react-router-dom';
import { TranslatedCorrelationTrackerView } from './CorrelationTrackerView';

import { AtlasEngineContext } from '../../../lib/index';
import { GenericViewProps } from '../../GenericViewProps';

type CorrelationTrackerViewParameters = {
  correlationId: string;
}

export function CorrelationTrackerViewWithRouter(genericViewProps: GenericViewProps): JSX.Element {
  const atlasEngineService = useContext(AtlasEngineContext);
  const { correlationId } = router.useParams<CorrelationTrackerViewParameters>();
  const { search } = router.useLocation();

  if (!atlasEngineService) {
    throw new Error('Atlas Engine Service missing in app context');
  }

  if (!correlationId) {
    return <span>Error</span>;
  }

  const params = new URLSearchParams(search);
  const autoNavigate = params.get('autoNavigate') !== 'false';

  return (
    <TranslatedCorrelationTrackerView
      {...genericViewProps}
      correlationId={correlationId}
      autoNavigate={autoNavigate}
      atlasEngineService={atlasEngineService}
    />
  );
}
